import {UserRole} from './user-role.model';

export class PrincipalMask {

  role: UserRole;
  publisherId: string;
  contentOwnerId: string;

}
